import { TooltipProvider, TooltipTrigger, TooltipContent, Tooltip as BaseTooltip } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function Tooltip({
  label,
  children,
  asChild = false,
  side,
  className,
  cursor = "help",
  open,
  onOpenChange,
}: {
  asChild?: boolean;
  label?: string;
  children: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left" | undefined;
  className?: string;
  cursor?: "help" | "pointer";
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) {
  if (!label) return children;

  return (
    <TooltipProvider>
      <BaseTooltip open={open} onOpenChange={onOpenChange}>
        <TooltipTrigger asChild={asChild}>
          <div
            className={cn("touch-manipulation", cursor === "pointer" ? "cursor-pointer" : "cursor-help")}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {children}
          </div>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className={`max-w-[70vw] break-words p-2 text-sm ${className}`}
          sideOffset={8}
          align="start"
          alignOffset={-4}
          collisionPadding={16}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <p className="whitespace-normal">{label}</p>
        </TooltipContent>
      </BaseTooltip>
    </TooltipProvider>
  );
}
